import React from "react";

const SidebarTitle = props => {
  const { title, currentSubStep, totalSteps } = props;
  return (
    <div className="sidebar-title">
      {title ? title.toUpperCase() : ""} {currentSubStep}/{totalSteps}
    </div>
  );
};

export default SidebarTitle;
